const initialState = [];
//
export default function cm0001(state = initialState, action) {
  switch (action.type) {
    case 'SET_CM0001':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CM0001_ERROR':
      return state;
    default:
      return state;
  }
}
